import { Middleware } from 'redux';
import getLogger, { ILogger } from '../../../Core/Logger';
import { ActionTypes } from '../../Actions/Actions';
import Core from '../../../Core/Core';

const logger: ILogger = getLogger('[SAVE_ACTIONS]:');

export const saveActions: Middleware = store => next => action => {
    // @ts-ignore //suppress unused ts error
    const oldState = store.getState();
    next(action);
    const newState = store.getState();

    if (
        action.type === ActionTypes.ADD_GAME_BOOSTER ||
        action.type === ActionTypes.STORE_GAME_BOOSTER ||
        action.type === ActionTypes.REMOVE_STORED_BOOSTER
    ) {
        saveData(new Map([['boosters', [...newState.StateBoosters.availableBoosters]]]));
    }

    if (action.type === ActionTypes.UPDATE_COINS) {
        saveData(new Map([['coin', newState.StateCurrency.coin]]));
    }

    if (action.type === ActionTypes.UPDATE_HEARTS) {
        saveData(
            new Map([
                ['heart', newState.StateCurrency.heart],
                ['lastLifeTime', newState.StateCurrency.ts],
            ])
        );
    }

    if (action.type === ActionTypes.INTERSTITIAL_AD_WATCHED) {
        saveData(new Map([['lastInterstitialDate', newState.StatePlayer.lastInterstitialDate]]));
    }

    if (
        action.type === ActionTypes.UPDATE_MAP_DATA ||
        action.type === ActionTypes.UNLOCK_MAP_LEVEL
    ) {
        saveData(new Map([['completedLevels', { ...newState.StatePlayer.mapLevels }]]));
    }

    if (action.type === ActionTypes.UNLOCK_MAP_LEVEL) {
        saveData(new Map([['lastLevelIndex', newState.StatePlayer.lastLevelIndex]]));
    }

    if (action.type === ActionTypes.LEVEL_COMPLETE || action.type === ActionTypes.UPDATE_MAP_DATA) {
        saveData(
            new Map([
                ['levelId', newState.StatePlayer.levelId],
                ['totalStars', newState.StatePlayer.totalStars],
            ])
        );
    }

    if (action.type === ActionTypes.UNLOCK_MAP) {
        saveData(new Map([['unlockedMaps', newState.StatePlayer.unlocked]]));
    }

    if (action.type === ActionTypes.ADD_CHEST || action.type === ActionTypes.CHANGE_CHEST_STATE) {
        saveData(new Map([['unlockedChests', newState.StatePlayer.unlockedChests]]));
    }

    if (action.type === ActionTypes.TOGGLE_SOUND) {
        saveData(new Map([['isSoundOn', newState.StateSound.soundFx.toString()]]));
    }

    if (action.type === ActionTypes.TOGGLE_MUSIC) {
        saveData(new Map([['isMusicOn', newState.StateSound.music.toString()]]));
    }

    if (action.type === ActionTypes.VISIT_MAP) {
        saveData(new Map([['visitedMaps', newState.StatePlayer.visited]]));
    }

    if (action.type === ActionTypes.OPT_IN_REWARDED) {
        saveData(new Map([['optInRewardDate', newState.StateSocial.optInRewardDate]]));
    }

    if (action.type === ActionTypes.OPT_IN_SHORTCUT_REWARDED) {
        saveData(
            new Map([['optInShortcutRewardDate', newState.StatePlayer.optInShortcutRewardDate]])
        );
    }

    if (action.type === ActionTypes.RECEIVE_MESSAGE) {
        saveData(new Map([['messageIds', newState.StateSocial.messageIds]]));
    }

    if (action.type === ActionTypes.SEND_COINS || action.type === ActionTypes.RESET_SEND_COINS) {
        saveData(new Map([['sentCoins', newState.StateSocial.sentCoins]]));
    }

    if (action.type === ActionTypes.SET_ACTIVE_COLLECTION) {
        saveData(new Map([['activeCollection', newState.StatePlayer.activeCollection]]));
    }

    if (action.type === ActionTypes.SET_COLLECTABLES_PROGRESS) {
        saveData(new Map([['collectablesProgress', newState.StatePlayer.collectablesProgress]]));
    }

    if (
        action.type === ActionTypes.ADD_GIFT_TO_COUNTER ||
        action.type === ActionTypes.RESET_GIFT_COUNTER
    ) {
        saveData(new Map([['sharedGiftsCount', newState.StateSocial.sharedGiftsCount]]));
    }

    if (action.type === ActionTypes.SEND_GIFT || action.type === ActionTypes.RESET_SEND_GIFT) {
        saveData(new Map([['sentGifts', newState.StateSocial.sentGifts]]));
    }

    if (
        action.type === ActionTypes.REQUEST_GIFT ||
        action.type === ActionTypes.RESET_REQUEST_GIFT
    ) {
        saveData(new Map([['requestedGifts', newState.StateSocial.requestedGifts]]));
    }

    if (action.type === ActionTypes.GAME_TRACKING) {
        saveData(new Map([['tracked', newState.StateTracking.tracked]]));
    }

    if (action.type === ActionTypes.ADD_INVITATION) {
        saveData(new Map([['pendingInvites', newState.StateSocial.pendingInvitations]]));
    }

    if (
        action.type === ActionTypes.INVITE_CONFIRMED ||
        action.type === ActionTypes.DELETE_INVITE_CONFIRMED
    ) {
        saveData(new Map([['confirmedInvites', newState.StateSocial.confirmedInvitations]]));
    }

    if (action.type === ActionTypes.STORE_RECEIVED_INVITE) {
        saveData(new Map([['receivedInvites', newState.StateSocial.receivedInvitations]]));
    }

    if (action.type === ActionTypes.SET_PRICE_WHEEL_COOLDOWN) {
        saveData(new Map([['prizeWheelCooldown', newState.StatePlayer.prizeWheelCooldown]]));
    }
    if (
        action.type === ActionTypes.MISSION_INIT ||
        action.type === ActionTypes.MISSION_COUNT ||
        action.type === ActionTypes.MISSION_COMPLETE ||
        action.type === ActionTypes.MISSION_REPLACE ||
        action.type === ActionTypes.MISSION_REFRESH ||
        action.type === ActionTypes.MISSION_REFRESH_COMPLETE
    ) {
        saveData(new Map([['missions', { ...newState.StateMissions.missions }]]));
    }

    if (
        action.type === ActionTypes.MISSION_REFRESH ||
        action.type === ActionTypes.MISSION_REFRESH_COMPLETE
    ) {
        saveData(new Map([['missionRefreshTimer', newState.StateMissions.refreshTimer]]));
    }

    if (
        action.type === ActionTypes.MISSION_COMPLETE ||
        action.type === ActionTypes.MISSION_MILESTONE_REACHED ||
        action.type === ActionTypes.UPDATE_MISSION_COUNT
    ) {
        saveData(new Map([['missionsCompleted', newState.StateMissions.completedCount]]));
    }

    if (action.type === ActionTypes.SET_MISSION_REWARD_CLAIMED) {
        saveData(new Map([['claimedRewards', newState.StateMissions.claimedRewards]]));
    }

    if (action.type === ActionTypes.MISSION_INIT || action.type === ActionTypes.MISSIONS_SHOWN) {
        saveData(new Map([['missionsShown', newState.StateMissions.missionsShown.toString()]]));
    }

    if (action.type === ActionTypes.SAVE_PURCHASE) {
        saveData(new Map([['purchases', newState.StatePlayer.purchases]]));
    }

    if (action.type === ActionTypes.SHOP_OPENED) {
        saveData(new Map([['shopHasBeenOpened', newState.StatePlayer.shopHasBeenOpened]]));
    }

    if (action.type === ActionTypes.SHOP_GIFT) {
        saveData(new Map([['shopGift', newState.StatePlayer.shopGift]]));
    }

    return;

    function saveData(keys: Map<string, unknown>): Promise<unknown> {
        const proms: Array<Promise<unknown>> = [];

        keys.forEach((value, key) => {
            proms.push(Core.sdk.data.saveData(key, value));
        });

        return Promise.all(proms).catch(err => {
            logger.debug(['error saving progress', err, keys]);
        });
    }
};
